import React, { ReactNode } from 'react';
// Styles
import styles from './roundlabel.module.scss';

interface IRoundLabelProps {
    text: string;
    showBorder?: boolean;
    borderColor?: string;
    children?: ReactNode;
    className?: string;
    textColor?: string;
}

export const RoundLabel = ({
    text = '',
    showBorder = false,
    borderColor = '',
    children,
    className = '',
    textColor = '',
}: IRoundLabelProps): JSX.Element => {
    const hasCustomBorderColor = showBorder && !!borderColor;
    return (
        <div
            className={`${styles.roundLabel} ${showBorder && styles.roundLabelBorder} ${
                className && className
            } d-flex align-items-center`}
            style={hasCustomBorderColor ? { borderColor: borderColor } : {}}
        >
            {children}
            <div dir="auto" className="text-truncate" style={textColor ? { color: textColor } : {}}>
                {text}
            </div>
        </div>
    );
};
